<core-popup #popup [props]="popupProps" [steps]="popupSteps" (onClosing)="close()"></core-popup>
